import InstitutionAmlCtfSanctionsForm from '@/features/institution/aml-ctf-sanctions/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingAmlCtfSanctionsPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="amlCtfSanctions" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionAmlCtfSanctionsForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingAmlCtfSanctionsPage.displayName = 'InstitutionOnboardingAmlCtfSanctionsPage';

export default InstitutionOnboardingAmlCtfSanctionsPage;
